<template>
<m-pageframe
    :title="title"
>
<v-container
    v-show="!is_auto_creating"
    fluid
    style="padding: 25px"
>

    
    <m-auto-message-template-search-table
        ref="autoMessageTable"
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            test_acknowledgement: false,
            consent_acknowledgement: false,
            is_auto_creating: false,
        }
    },

    mounted() {
        // Add cache prevention meta tags to prevent browser caching
        this.addCachePreventionMeta();

        // Handle browser back button to ensure fresh data
        this.handleBrowserNavigation();

        this.checkForAutoAdd();
    },

    beforeDestroy() {
        // Clean up meta tags when component is destroyed
        this.removeCachePreventionMeta();

        // Remove event listener
        window.removeEventListener('popstate', this.onBrowserBack);
    },

    methods: {
        addCachePreventionMeta() {
            // Add meta tags to prevent caching
            const meta_tags = [
                { name: 'cache-control', content: 'no-cache, no-store, must-revalidate' },
                { name: 'pragma', content: 'no-cache' },
                { name: 'expires', content: '0' }
            ];

            meta_tags.forEach(tag => {
                const existing_meta = document.querySelector(`meta[name="${tag.name}"]`);
                if (!existing_meta) {
                    const meta = document.createElement('meta');
                    meta.name = tag.name;
                    meta.content = tag.content;
                    meta.setAttribute('data-auto-messages-cache-prevention', 'true');
                    document.head.appendChild(meta);
                }
            });
        },

        removeCachePreventionMeta() {
            // Remove cache prevention meta tags
            const meta_tags = document.querySelectorAll('meta[data-auto-messages-cache-prevention="true"]');
            meta_tags.forEach(meta => meta.remove());
        },

        handleBrowserNavigation() {
            // Listen for browser back/forward navigation
            this.onBrowserBack = () => {
                // Force refresh of the table component when user navigates back
                this.forceRefreshTable();
            };

            window.addEventListener('popstate', this.onBrowserBack);
        },

        forceRefreshTable() {
            // Force refresh of the auto-message table component
            this.$nextTick(() => {
                if (this.$refs.autoMessageTable && this.$refs.autoMessageTable.update) {
                    this.$refs.autoMessageTable.update();
                }
            });
        },

        checkForAutoAdd() {
            if (this.$route.query.auto_add !== 'true') return;

            this.is_auto_creating = true;
            this.$rc.showSpinner();

            const template_context = this.$route.query.template_context;
            const order_confirmation_settings_id = this.$route.query.order_confirmation_settings_id;
            
            const tryTrigger = () => {
                if (this.$refs.autoMessageTable?.uncreated_templates) {
                    this.$refs.autoMessageTable.triggerAddWithPreselection(template_context, order_confirmation_settings_id);
                } else {
                    setTimeout(tryTrigger, 100);
                }
            };

            this.$nextTick(tryTrigger);

            this.$router.replace({
                name: this.$route.name,
                params: this.$route.params,
                query: {},
            });
        }
    },

    computed: {
        title() {

            if ( this.organization_label == null )
            {
                return "Automated Messages";
            }

            return "Automated Messages: "+this.organization_label;
        },
    },
}
</script>

<style lang="scss" scoped>


</style>